import { Component, KeyValueDiffers, OnInit, KeyValueDiffer, OnChanges, ChangeDetectorRef, ElementRef } from '@angular/core';

import { filter, Observable, tap, debounce, of, timer } from 'rxjs';

import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';
import { BlockComponent } from '../../../../Common/PageBuilder/components/Block/block.component';
import { BlockDisplayElementChangedEvent } from '../../../../Common/PageBuilder/models/block-display-element-changed-event.model';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { TableOfContentBlockDataModel } from '../../models/table-of-content-block-data.model';
import { TableOfContentDisplayElementModel } from '../../models/table-of-content-display-element.model';
import { BriefingBlockTypeApiEnum } from '@api/briefings/enum/briefing-block-type-api.enum';

@Component({
    selector: 'agpr-table-of-content-block',
    templateUrl: './table-of-content-block.component.html',
    styleUrls: ['./table-of-content-block.component.scss'],
    standalone: false
})
export class TableOfContentBlockComponent extends BlockComponent implements OnInit, OnChanges {

    blockData: TableOfContentBlockDataModel[];
    settingsDiffer: KeyValueDiffer<string, any>;
    tableOfContentRenderable: boolean;
    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        protected changeDetectorRef: ChangeDetectorRef,
        public clickOutsideService: ClickOutsideService,
        public el: ElementRef
    ) {
        super(differs, pageBuilderService, changeDetectorRef, clickOutsideService, el);
    }

    ngOnInit() {
        super.ngOnInit();
        this.settingsDiffer = this.differs.find((<TableOfContentDisplayElementModel>this.block.displayElement).settings).create();

        this.subscriptions.push(
            this.pageBuilderService.getBlocks().subscribe(
                (blocks) => {
                    (<TableOfContentDisplayElementModel>this.block.displayElement).setBrifeingBlockSummaryData(blocks);
                    this.ngOnChanges();
                    this.changeDetectorRef.detectChanges();
                }
            ),
            this.subscribeToBlockChanges().subscribe()
        );
    }

    // we have to update the mention count for the title blocks in TOC
    updateMentionCounts(blocks): TableOfContentBlockDataModel[]  {
        if (!blocks) {
            return;
        }
        let tocBlocks: TableOfContentBlockDataModel[] = [];
        let currentTitleBlock: TableOfContentBlockDataModel = null;
        let tempMentionBlocks: TableOfContentBlockDataModel[] = [];

        blocks.forEach(block => {
            if (block.type === BriefingBlockTypeApiEnum.TITLE) {
                if (currentTitleBlock) {
                    tocBlocks.push(currentTitleBlock);
                }
                if (tempMentionBlocks?.length) {
                    tocBlocks = tocBlocks.concat(tempMentionBlocks);
                    tempMentionBlocks = [];
                }
                currentTitleBlock = block;
                currentTitleBlock.mention_count = 0;
            } else if ((block.type === BriefingBlockTypeApiEnum.CURATED_MENTION_LIST) || (block.type === BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST)) {
                let mentionCount = 0;
                if (block.mentions) {
                    mentionCount = block.mentions.length;
                }
                if (currentTitleBlock) {
                    currentTitleBlock.mention_count += mentionCount;
                    currentTitleBlock.includeMentionCount = true;
                }
                block.mention_count = mentionCount;
                tempMentionBlocks.push(block);
            }
        });

        if (currentTitleBlock) {
            tocBlocks.push(currentTitleBlock);
            currentTitleBlock = null;
        }

        if (tempMentionBlocks?.length) {
            tocBlocks = tocBlocks.concat(tempMentionBlocks);
            tempMentionBlocks = [];
        }

        return tocBlocks;
    }

    subscribeToBlockChanges(): Observable<BlockDisplayElementChangedEvent> {
        return this.pageBuilderService.getBlockDisplayElementChanged().pipe(
            filter((event) => !!event?.block?.type),
            debounce((event) => event.block === this.block ? of(null) : timer(300)),
            tap(event => {
                if (
                    event.block.type.key === BriefingBlockTypeApiEnum.TABLE_OF_CONTENT ||
                    event.block.type.key === BriefingBlockTypeApiEnum.TITLE ||
                    event.block.type.key === BriefingBlockTypeApiEnum.CURATED_MENTION_LIST ||
                    event.block.type.key === BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST
                ) {
                    this.ngOnChanges();
                    this.changeDetectorRef.detectChanges();
                }
            }
            )
        );
    }

    updateTwigData() {
        this.twigData = Object.assign(
            {},
            this.block.displayElement,
            {orderId: this.pageBuilderService.getFlattenedIndex(this.block)},
            {blocks: this.updateMentionCounts((<TableOfContentDisplayElementModel>this.block.displayElement).briefingBlockSummaryData) }
        );
    }
}
